module.exports = __webpack_public_path__ + "static/media/6tsel.e6d3f4de.png";